import React, {Component} from 'react';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {AccessService} from '../../../utils/AccessService';
import {useFicha21} from '../../../context/UserModulesContext';
import {ClientHeader} from '../ClientHeader';
import {ClientTabs} from '../ClientTabs';
import {Spinner} from '../../Spinner';
import {BUSummaryBox} from './BUSummaryBox';
import {PlatformsBox} from './PlatformsBox';
import {QuickConnectAccountModal} from './QuickConnectAccountModal';
import {QuickActionsBox} from './QuickActionsBox';
import {ReportsPreviewBox} from './ReportsPreviewBox';
import {ActivityLogPreviewBox} from './ActivityLogPreviewBox';
import {MemoryPreviewBox} from './MemoryPreviewBox';
import {IAPreviewBox} from './IAPreviewBox';
import {MediaPlanActionItem} from './MediaPlanActionItem';
import {ActivityLogCommentModal} from '../activity_log/ActivityLogCommentModal';
import {AddBusinessUnitModal} from '../AddBusinessUnitModal';
import {CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_ECOMMERCE} from '../../channels/channels';
import {TemplatePickerModal} from '../../reports/TemplatePickerModal';
import {withTranslation} from 'react-i18next';
import {fetchCustomMetrics} from '../../../hooks/useCustomMetrics';
import {setCustomMetricLabelsCache} from '../../dashboard/columns';
import './ControlCentral.scss';

class ControlCentralContentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            businessUnits: null,
            clientAdAccounts: null,
            clientStores: null,
            channels: null,
            reports: [],
            activityLogEntries: [],
            loadingClient: true,
            loadingReports: true,
            loadingActivityLog: true,
            businessType: null,
            ignoredChannels: null,
            generating: false,
            showTemplateModal: false,
            showCommentModal: false,
            isSubmittingComment: false,
            showConnectModal: false,
            connectModalChannel: null,
        };

        this.handleGenerateReport = this.handleGenerateReport.bind(this);
        this.handleGenerateTemplate = this.handleGenerateTemplate.bind(this);
        this.toggleTemplateModal = this.toggleTemplateModal.bind(this);
        this.handleDeleteReport = this.handleDeleteReport.bind(this);
        this.handleCancelReport = this.handleCancelReport.bind(this);
        this.toggleCommentModal = this.toggleCommentModal.bind(this);
        this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
        this.handleAfterSuccessfulBUSubmit = this.handleAfterSuccessfulBUSubmit.bind(this);
        this.handleOpenAddBUModal = this.handleOpenAddBUModal.bind(this);
        this.handleConnectChannel = this.handleConnectChannel.bind(this);
        this.toggleConnectModal = this.toggleConnectModal.bind(this);
        this.handleConnectSuccess = this.handleConnectSuccess.bind(this);
        this.handleIgnoreChannel = this.handleIgnoreChannel.bind(this);
        this.handleUnignoreChannel = this.handleUnignoreChannel.bind(this);
    }

    componentDidMount() {
        this.fetchClientData();
        this.loadModuleDependentData();
        this.fetchBusinessType();
        // Objetivos con métrica custom en la tabla de BUs: hidratar el cache de display_names
        // para no mostrar el raw "CUSTOM:6" (mismo patrón que ClientMonitoring).
        fetchCustomMetrics().then((items) => {
            setCustomMetricLabelsCache(items);
            this.setState({customMetricLabelsReady: true});
        });
    }

    // Tipo de negocio del cliente (Configuración → Contexto del negocio): PlatformsBox lo usa
    // para no sugerir integraciones que no aplican (ej. Shopify a un cliente de lead gen).
    fetchBusinessType() {
        new APIClient(API_URL + 'client/' + this.props.clientId + '/profile').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({businessType: data.data.business_type || null});
            }
        });
    }

    // Los módulos vienen del provider: pueden no estar en el primer render (fetch async), así que
    // los widgets que dependen de ellos se piden en cuanto llegan, una sola vez.
    componentDidUpdate(prevProps) {
        if (!prevProps.modulesLoaded && this.props.modulesLoaded) this.loadModuleDependentData();
    }

    loadModuleDependentData() {
        if (!this.props.modulesLoaded || this._moduleDataRequested) return;
        this._moduleDataRequested = true;

        if (this.hasReportsModule()) {
            this.fetchReports();
        } else {
            this.setState({loadingReports: false});
        }
        if (this.hasActivityLogModule()) {
            this.fetchActivityLog();
        } else {
            this.setState({loadingActivityLog: false});
        }
    }

    hasModule(moduleName) {
        return (this.props.modules || []).includes(moduleName);
    }

    hasAgentModule() {
        return this.hasModule(AccessService.MODULE_AGENT);
    }

    hasReportsModule() {
        return this.hasModule(AccessService.MODULE_REPORTS);
    }

    hasActivityLogModule() {
        return this.hasModule(AccessService.MODULE_ACTIVITY_LOG);
    }

    fetchClientData() {
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    name: data.data.name,
                    businessUnits: data.data.business_units,
                    clientAdAccounts: data.data.client_ad_accounts,
                    clientStores: data.data.client_stores,
                    channels: data.data.channels,
                    ignoredChannels: data.data.ignored_channels || [],
                    loadingClient: false,
                });
            } else {
                this.setState({loadingClient: false});
            }
        });
    }

    fetchReports() {
        new APIClient(API_URL + 'reports/?client_id=' + this.props.clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    reports: data.data.reports || [],
                    loadingReports: false,
                });
            } else {
                this.setState({loadingReports: false});
            }
        });
    }

    // Capas del digest del Panel con ficha v2: todas — el colapso de ráfagas server-side evita
    // que 5 ticks de la misma alerta ocupen todo el widget (el problema del widget legacy).
    TIMELINE_CATEGORIES = 'PLATFORM_CHANGE,EXTERNAL,MEMORY_OPS,BUDGET,CONFIGURATION,STATUS,ACCOUNTS,INTEGRATIONS,REPORTS,AGENT,ALERTS,COMMENT,TEAM';

    fetchActivityLog() {
        let url = API_URL + 'client/' + this.props.clientId + '/activity-log/?page_size=5';
        if (this.props.ficha21) {
            url += '&categories=' + this.TIMELINE_CATEGORIES + '&tz_offset=' + new Date().getTimezoneOffset();
        }
        new APIClient(url).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    activityLogEntries: data.data.entries || [],
                    loadingActivityLog: false,
                });
            } else {
                this.setState({loadingActivityLog: false});
            }
        });
    }

    handleGenerateReport() {
        this.setState({showTemplateModal: true});
    }

    toggleTemplateModal() {
        this.setState({showTemplateModal: !this.state.showTemplateModal});
    }

    handleGenerateTemplate(templateSlug, visibleToClients = true, isPublic = true, scope = null, userTemplateId = null) {
        this.setState({generating: true, showTemplateModal: false});
        const body = {
            action_type: 'template_report',
            client_id: this.props.clientId,
            is_visible_to_clients: visibleToClients,
            is_public: isPublic,
            // El picker abre el wizard de alcance para toda plantilla oficial y lo emite como
            // 4to argumento; esta pantalla lo descartaba, así que el usuario elegía una cuenta
            // o una Línea y recibía el informe del cliente entero. Mismo modo de falla que el
            // del template, otra variable.
            data_source_type: scope?.data_source_type || null,
            ad_account_id: scope?.ad_account_id || null,
            business_unit_id: scope?.business_unit_id || null,
        };
        // Con una plantilla propia el picker deja templateSlug en null: mandar los dos
        // haría que el backend caiga al semanal oficial.
        if (userTemplateId) {
            body.user_template_id = userTemplateId;
        } else {
            body.template_slug = templateSlug;
        }
        new APIClient(API_URL + 'agent/trigger-action/').call('POST', body).then((data) => {
            this.setState({generating: false});
            if (data && data.status === 'OK') {
                const newReport = {
                    report_id: data.data.report_id,
                    title: this.props.t('client_reports.generating'),
                    generated_at: new Date().toISOString(),
                    status: 'PROCESSING',
                    url: null,
                    block_count: 0,
                    can_delete: true,
                };
                this.setState(prevState => ({
                    reports: [newReport, ...prevState.reports],
                }));
            } else if (data) {
                const {t} = this.props;
                // NETWORK_ERROR existe justamente para que un microcorte NO dispare un alert()
                // (ver el contrato en APIClient.js). El else de abajo lo agarraba igual.
                if (data.status === 'NETWORK_ERROR') return;
                if (data.status === 'ALREADY_PROCESSING') {
                    alert(t('client_reports.error_already_processing'));
                } else {
                    // El error_message del backend viene sin traducir (y a veces en castellano
                    // hardcodeado): al usuario le va una clave i18n, el crudo queda en consola.
                    console.error('[trigger-action]', data.status, data.error_message);
                    alert(t('client_reports.error_generic'));
                }
            }
        });
    }

    handleDeleteReport(reportId) {
        const {t} = this.props;
        if (!window.confirm(t('client_reports.delete_confirm'))) return;

        new APIClient(API_URL + 'reports/' + reportId + '/').call('DELETE').then((data) => {
            if (data && data.status === 'OK') {
                this.setState(prevState => ({
                    reports: prevState.reports.filter(r => r.report_id !== reportId),
                }));
            }
        });
    }

    handleCancelReport(reportId) {
        const {t} = this.props;
        if (!window.confirm(t('client_reports.cancel_confirm'))) return;

        new APIClient(API_URL + 'reports/' + reportId + '/').call('DELETE').then((data) => {
            if (data && (data.status === 'OK' || data.status === 'FORBIDDEN')) {
                this.fetchReports();
            }
        });
    }

    toggleCommentModal() {
        this.setState({showCommentModal: !this.state.showCommentModal});
    }

    handleCommentSubmit(commentText, buId) {
        this.setState({isSubmittingComment: true});
        const body = {comment_text: commentText};
        if (buId) body.business_unit_id = buId;

        new APIClient(API_URL + 'client/' + this.props.clientId + '/activity-log/').call('POST', body).then((data) => {
            this.setState({isSubmittingComment: false});
            if (data && data.status === 'OK') {
                this.setState({showCommentModal: false});
                this.fetchActivityLog();
            } else if (data) {
                alert(data.error_message || 'Error');
            }
        });
    }

    handleConnectChannel(channel) {
        const info = CHANNEL_INFO_BY_CHANNEL[channel];
        if (info && info.channelType === CHANNEL_TYPE_ECOMMERCE) {
            this.props.history.push(`/client/${this.props.clientId}/conections`);
            return;
        }
        this.setState({showConnectModal: true, connectModalChannel: channel});
    }

    toggleConnectModal() {
        this.setState({showConnectModal: !this.state.showConnectModal, connectModalChannel: null});
    }

    handleConnectSuccess() {
        this.fetchClientData();
    }

    handleIgnoreChannel(channel) {
        const body = {channel: channel};
        new APIClient(API_URL + 'client/' + this.props.clientId + '/ignore-channel/').call('POST', body).then((data) => {
            if (data && data.status === 'OK') {
                this.fetchClientData();
            }
        });
    }

    handleUnignoreChannel(channel) {
        const body = {channel: channel};
        new APIClient(API_URL + 'client/' + this.props.clientId + '/unignore-channel/').call('POST', body).then((data) => {
            if (data && data.status === 'OK') {
                this.fetchClientData();
                this.handleConnectChannel(channel);
            }
        });
    }

    handleOpenAddBUModal() {
        if (this.addBUModal) {
            this.addBUModal.toggle();
        }
    }

    handleAfterSuccessfulBUSubmit(businessUnitId) {
        this.props.history.push(`/business-unit/${businessUnitId}/accounts?showAddAccountModal=true`);
    }

    render() {
        const isLoading = this.state.loadingClient && !this.props.modulesLoaded;
        const showHeader = this.props.showHeader !== false;
        const showTabs = this.props.showTabs !== false;
        const readOnly = this.props.readOnly === true;

        if (isLoading) {
            return (
                <section className="section-content">
                    {showHeader && <ClientHeader name={this.state.name}/>}
                    {showTabs && <ClientTabs clientId={this.props.clientId}/>}
                    <div className="section-body" style={{display: 'flex', justifyContent: 'center', padding: '3em 0'}}>
                        <Spinner color="positive"/>
                    </div>
                </section>
            );
        }

        const businessUnits = (this.state.businessUnits || []).map(bu => ({
            id: bu.id,
            name: bu.name,
        }));

        // El Panel entero sólo existe con la ficha 2.1, así que acá `ficha21` ya es true: las cards
        // se gatean por su capability real. El Media Plan es del tier IA (no del rediseño), por eso
        // va por `mediaPlanEnabled` y no por el flag de la ficha.
        const fichaV2 = this.props.ficha21;
        const hasMemory = this.props.clientMemoryLevel === AccessService.MEMORY_LEVEL_MEDIO
            || this.props.clientMemoryLevel === AccessService.MEMORY_LEVEL_TOTAL;
        const hasMcp = this.hasModule(AccessService.MODULE_DASHBO_MCP);
        const showMediaPlan = this.props.mediaPlanEnabled === true && hasMcp && !readOnly;

        return (
            <section className="section-content">
                {showHeader && <ClientHeader name={this.state.name}/>}
                {showTabs && <ClientTabs clientId={this.props.clientId}/>}

                <div className="section-body">
                    {showMediaPlan && (
                        <MediaPlanActionItem clientId={this.props.clientId}/>
                    )}
                    <div className="control-central-grid">
                        <div className="control-central-main">
                            <BUSummaryBox
                                businessUnits={this.state.businessUnits}
                                clientId={this.props.clientId}
                                onAddBU={readOnly ? null : this.handleOpenAddBUModal}
                                showMediaPlanCta={showMediaPlan}
                            />

                            {fichaV2 && hasMemory && !readOnly && (
                                <MemoryPreviewBox clientId={this.props.clientId}/>
                            )}

                            <PlatformsBox
                                clientId={this.props.clientId}
                                clientAdAccounts={this.state.clientAdAccounts}
                                clientStores={this.state.clientStores}
                                channels={this.state.channels}
                                ignoredChannels={this.state.ignoredChannels}
                                businessType={this.state.businessType}
                                onConnectChannel={this.handleConnectChannel}
                                onIgnoreChannel={this.handleIgnoreChannel}
                                onUnignoreChannel={this.handleUnignoreChannel}
                                readOnly={readOnly}
                            />
                        </div>

                        <div className="control-central-sidebar">
                            <QuickActionsBox
                                clientId={this.props.clientId}
                                modules={this.props.modules}
                                onAddNote={readOnly ? null : this.toggleCommentModal}
                                onAddBU={readOnly ? null : this.handleOpenAddBUModal}
                                onGenerateReport={this.handleGenerateReport}
                                generating={this.state.generating}
                                readOnly={readOnly}
                            />

                            {fichaV2 && hasMcp && !readOnly && (
                                <IAPreviewBox clientId={this.props.clientId}/>
                            )}

                            {this.hasReportsModule() && (
                                <ReportsPreviewBox
                                    clientId={this.props.clientId}
                                    reports={this.state.reports}
                                    onDeleteReport={this.handleDeleteReport}
                                    onCancelReport={this.handleCancelReport}
                                />
                            )}

                            {!readOnly && this.hasActivityLogModule() && (
                                <ActivityLogPreviewBox
                                    clientId={this.props.clientId}
                                    entries={this.state.activityLogEntries}
                                    loading={this.state.loadingActivityLog}
                                    onAddNote={this.toggleCommentModal}
                                    fichaV2={fichaV2}
                                />
                            )}
                        </div>
                    </div>
                </div>

                {!readOnly && (
                    <ActivityLogCommentModal
                        isOpen={this.state.showCommentModal}
                        toggle={this.toggleCommentModal}
                        businessUnits={businessUnits}
                        onSubmit={this.handleCommentSubmit}
                        isSubmitting={this.state.isSubmittingComment}
                    />
                )}

                <AddBusinessUnitModal
                    ref={instance => { this.addBUModal = instance; }}
                    clientId={this.props.clientId}
                    clientName={this.state.name}
                    afterSuccessfulSubmit={this.handleAfterSuccessfulBUSubmit}
                    history={this.props.history}
                />

                <QuickConnectAccountModal
                    isOpen={this.state.showConnectModal}
                    toggle={this.toggleConnectModal}
                    channel={this.state.connectModalChannel}
                    clientId={this.props.clientId}
                    onSuccess={this.handleConnectSuccess}
                />

                <TemplatePickerModal
                    isOpen={this.state.showTemplateModal}
                    toggle={this.toggleTemplateModal}
                    clientId={this.props.clientId}
                    onGenerate={this.handleGenerateTemplate}
                    generating={this.state.generating}
                />
            </section>
        );
    }
}

const ControlCentralContentInner = withTranslation()(ControlCentralContentClass);

// Módulos, nivel de Memoria y flags salen del provider (fuente única). Antes esta pantalla pedía
// `access/modules` por su cuenta: abrir el Panel de un cliente lo pedía dos veces (acá + ClientTabs).
export function ControlCentralContent(props) {
    const {ficha21, mediaPlanEnabled, clientMemoryLevel, modules, loaded} = useFicha21();
    return <ControlCentralContentInner {...props} ficha21={ficha21} mediaPlanEnabled={mediaPlanEnabled}
                                       clientMemoryLevel={clientMemoryLevel} modules={modules}
                                       modulesLoaded={loaded}/>;
}
